import { FaQuoteLeft } from "react-icons/fa";
import { motion } from 'framer-motion';
const CARD_TEXT_HEIGHT = 120; // px
const ReviewCard = ({ text, name, image }) => {
  return (
    <motion.div
      whileHover={{ scale: 1.03 }}
      className="relative bg-teal-700  shadow-xl p-6 overflow-hidden group transition-transform duration-300 ease-in-out h-[300px]"
    >
      <FaQuoteLeft className="text-6xl text-slate-700 absolute top-4 left-4" />

      <div
        className={`mt-12 h-[${CARD_TEXT_HEIGHT}px] overflow-hidden group-hover:overflow-auto scrollbar-thin scrollbar-thumb-slate-400`}
      >
        <p className="text-white text-lg pt-4 font-medium leading-relaxed">
          {text}
        </p>
      </div>

      <div className="absolute bottom-4 left-6 flex items-center justify-between w-[90%]">
  <p className="font-semibold text-slate-800 text-xl" >{name}</p>
  <div className="relative">
    <img
      src={image}
      alt={name}
      className="w-20 h-20 rounded-full object-cover border-4 border-slate-800"
    />
  </div>
</div>

    </motion.div>
  );
};


export default ReviewCard;
